import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import { useEffect, useState, useContext } from "react";
import { useKeenSlider } from "keen-slider/react";
import Slide from "../Atomics/Slide/Slide";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight, faCircle } from "@fortawesome/free-solid-svg-icons";
import { SidebarContext } from "../../context/sidebar";

export default function PopularChannels({ data, title, type }) {
  const [sliderInstance, setSliderInstance] = useState(null);
  const { showMenu } = useContext(SidebarContext);
  const [ref, slider] = useKeenSlider({
    loop: true,
    mode: "snap",
    slides: {
      perView: 6,
      spacing: 8,
    },
    breakpoints: {
      "(max-width: 1250px)": {
        slides: { perView: 4, spacing: 6 },
      },
      "(max-width: 1040px)": {
        slides: { perView: 3, spacing: 6 },
      },
      "(max-width: 843px)": {
        slides: { perView: 2, spacing: 6 },
      },
      "(max-width: 423px)": {
        slides: { perView: 1, spacing: 6 },
      },
    },
    created(s) {
      setSliderInstance(s);
    },
  });

  useEffect(() => {
    const interval = setInterval(() => {
      sliderInstance?.next();
    }, 8000);
    return () => clearInterval(interval);
  }, [sliderInstance]);

  useEffect(() => {
    if (!sliderInstance || !ref.current) return;
    const resizeObserver = new ResizeObserver(() => {
      sliderInstance.update();
    });
    resizeObserver.observe(ref.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [sliderInstance, ref]);

  useEffect(() => {
    if (sliderInstance) {
      const timer = setTimeout(() => {
        sliderInstance.update();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [showMenu, sliderInstance]);

  return (
    <>
      <div className="video-block section-padding ">
        <Row>
          <Col md={12}>
            <SectionHeader heading={title} />
          </Col>
        </Row>

        <Row className="gx-3 gy-4">
          {data?.content_items?.length > 0 ? (
            <div className="slider-wrapper" style={{ position: "relative", width: "100%", padding: "0px 0px" }}>
              <div ref={ref} className="keen-slider">
                {data?.content_items?.map((item, index) => (
                  <div className="keen-slider__slide" key={index}>
                    {type === "video" ? (
                      <Slide
                        type="video"
                        videoCover={item?.cover ? item?.cover : "img/v4.png"}
                        videoTitle={item.title}
                        videoCategory={item.categorys?.name}
                        videoCountedViews={item.counted_views}
                        videoPublishedDate={item.published_date}
                        viedoChannelName={item.channel?.name}
                        videoChannelId={item.channel?.id}
                        videoId={item?.id}
                      />
                    ) : (
                      <Slide
                        href={`/single-channel/${item?.id}`}
                        imgSrc={item.avatar}
                        label={item.name}
                        views={item.counted_view}
                        verified
                      />
                    )}
                  </div>
                ))}
              </div>

              <button
                className="custom-slick-btn custom-slick-prev"
                style={{ position: "absolute", left: "6px", top: "40%", zIndex: 2 }}
                onClick={() => sliderInstance?.prev()}
              >
                <FontAwesomeIcon icon={faAngleLeft} mask={faCircle} transform="shrink-7" />
              </button>

              <button
                className="custom-slick-btn custom-slick-next"
                style={{ position: "absolute", right: "6px", top: "40%", zIndex: 2 }}
                onClick={() => sliderInstance?.next()}
              >
                <FontAwesomeIcon icon={faAngleRight} mask={faCircle} transform="shrink-7" />
              </button>
            </div>
          ) : (
            <div className="mr-3">محتوایی برای این بخش وجود ندارد.</div>
          )}
        </Row>
      </div>
    </>
  );
}
